var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"submit-button-oval"},on:{"click":_vm.onClick}},[(!_vm.buttonText)?_c('RightArrowSvg'):_c('div',{staticClass:"buttonText"},[_vm._v(" "+_vm._s(_vm.buttonText)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }